<style src="./EventFilter.scss" lang="scss"></style>
<template>
  <form @submit.prevent="submitFilter" class="event-filter">
    <div class="columnfield dates">
      <label class="fieldcolumn date">
        <span class="title">Data Inicial</span>
        <input type="date" class="cp1-small-textbox" v-model="form.startDate" />
      </label>

      <label class="fieldcolumn date">
        <span class="title">Data Final</span>
        <input type="date" class="cp1-small-textbox" v-model="form.endDate" />
      </label>
    </div>

    <div class="columnfield info">
      <label class="fieldcolumn search">
        <span class="title">Princípio Ativo</span>
        <cp1-suggest-pativo placeholder="paracetamol" v-model="form.pativo" />
      </label>

      <label class="fieldcolumn search">
        <span class="title">Laboratório</span>
        <cp1-suggest-lab
          placeholder="prati"
          @selected="selectLab"
          v-model="selection.lab"
        />
      </label>
    </div>

    <div class="columnfield info">
      <label class="fieldcolumn search">
        <span class="title">1º Ranking</span>
        <cp1-suggest-distributor
          placeholder=""
          @selected="selectWinnerDistributor"
          v-model="selection.winnerDistributor"
        />
      </label>

      <div class="fieldcolumn search">
        <span class="title">Garantia</span>
        <div class="options">
          <button
            type="button"
            @click="toggleWithoutStrict"
            :class="{
              'cp1-button__active':
                form.guaranted && form.guaranted.includes('FALSE')
            }"
            class="cp1-small-button selection"
          >
            Sem
          </button>
          <button
            type="button"
            @click="toggleWithStrict"
            :class="{
              'cp1-button__active':
                form.guaranted && form.guaranted.includes('TRUE')
            }"
            class="cp1-small-button selection"
          >
            Com
          </button>
        </div>
      </div>
    </div>

    <div class="columnfield info">
      <label class="fieldcolumn">
        <span class="title">2º Ranking</span>
        <cp1-suggest-distributor
          placeholder=""
          @selected="selectSecondDistributor"
          v-model="selection.secondDistributor"
        />
      </label>

      <div class="fieldcolumn search">
        <span class="title">Resultado</span>
        <div class="options">
          <button
            type="button"
            @click="toggleWithoutResult"
            :class="{
              'cp1-button__active': form.result && form.result.includes('FALSE')
            }"
            class="cp1-small-button selection"
          >
            Sem
          </button>
          <button
            type="button"
            @click="toggleWithResult"
            :class="{
              'cp1-button__active': form.result && form.result.includes('TRUE')
            }"
            class="cp1-small-button selection"
          >
            Com
          </button>
        </div>
      </div>
    </div>
    <div class="columnfield info">
      <label class="fieldcolumn">
        <span class="title">3º Ranking</span>
        <cp1-suggest-distributor
          placeholder=""
          @selected="selectThirdDistributor"
          v-model="selection.thirdDistributor"
        />
      </label>
      <div class="fieldcolumn search">
        <span class="title">Somente Associado</span>
        <div class="options">
          <button
            type="button"
            @click="toggleAssociatedYes"
            :class="{ 'cp1-button__active': form.onlyAssociated }"
            class="cp1-small-button selection"
          >
            Sim
          </button>
          <button
            type="button"
            @click="toggleAssociatedNo"
            :class="{ 'cp1-button__active': !form.onlyAssociated }"
            class="cp1-small-button selection"
          >
            Não
          </button>
        </div>
      </div>
    </div>

    <div class="columnfield date">
      <label class="fieldcolumn date">
        <span class="title">Data Ranking</span>
        <input
          type="date"
          class="cp1-small-textbox"
          v-model="form.updateRankingDate"
        />
      </label>
    </div>

    <div class="fieldcolumn command">
      <button class="cp1-small-button btn-success button" :disabled="isLoading">
        Buscar
        <IconWait class="wait" v-if="isLoading"></IconWait>
      </button>
      <button
        type="button"
        class="cp1-small-button btn-primary download"
        :disabled="isCsvDownloadDisabled"
        @click="downloadCSV"
      >
        <div class="icon">
          <icon-download />
        </div>
      </button>
    </div>
  </form>
</template>

<script>
import {
  Cp1SuggestPativo,
  Cp1SuggestLab,
  Cp1SuggestDistributor
} from "@/components/primitives";
import { IconDownload, IconWait } from "@/components/primitives/icons";
import moment from "moment";

export default {
  name: "EventFilter",
  props: {
    isLoading: {
      default: false
    }
  },
  components: {
    Cp1SuggestPativo,
    Cp1SuggestLab,
    Cp1SuggestDistributor,
    IconDownload,
    IconWait
  },
  data: () => ({
    form: {
      pativo: "",
      lab: "",
      winnerDistributor: "",
      secondDistributor: "",
      thirdDistributor: "",
      startDate: null,
      endDate: null,
      guaranted: ["TRUE", "FALSE"],
      result: ["TRUE", "FALSE"],
      onlyAssociated: false,
      updateRankingDate: null
    },
    selection: {
      winnerDistributor: "",
      secondDistributor: "",
      thirdDistributor: ""
    },
    isCsvDownloadDisabled: false
  }),
  methods: {
    setEndDate(date) {
      const dt = moment(date).add(1, "d");
      return dt;
    },
    search() {
      this.setEndDate(this.form.startDate);
      const startDate =
        this.form.startDate &&
        moment(this.form.startDate, "YYYY-MM-DD 00:00:00").toDate();
      const endDate =
        this.form.endDate &&
        moment(
          this.setEndDate(this.form.endDate),
          "YYYY-MM-DD 00:00:00"
        ).toDate();
      const updateRankingDate =
        this.form.updateRankingDate &&
        moment(this.form.updateRankingDate, "YYYY-MM-DD 00:00:00").toDate();
      const form = {
        ...this.form,
        guaranted: this.formatBoolean(this.form.guaranted),
        result: this.formatBoolean(this.form.result),
        startDate,
        endDate,
        updateRankingDate
      };
      return form;
    },
    submitFilter() {
      if (!this.form.startDate || !this.form.endDate) return;
      const form = this.search();
      this.$emit("submit-filter", {
        ...form
      });
    },
    formatBoolean(v) {
      if (v.length === 2) {
        return null;
      }
      return v[0] === "TRUE";
    },
    selectLab(item) {
      this.form.lab = item && item.source && item.source._id;
    },
    selectWinnerDistributor(item) {
      this.form.winnerDistributor = item.source._id;
    },
    selectSecondDistributor(item) {
      this.form.secondDistributor = item.source._id;
    },
    selectThirdDistributor(item) {
      this.form.thirdDistributor = item.source._id;
    },
    toggleWithStrict() {
      const selection = [...this.form.guaranted];
      const withoutIndexOf = selection.indexOf("TRUE");
      if (withoutIndexOf > -1) {
        selection.splice(withoutIndexOf, 1);
      } else {
        selection.push("TRUE");
      }
      if (selection.length === 0) {
        return;
      }

      this.form.guaranted = selection;
    },
    toggleWithoutStrict() {
      const selection = [...this.form.guaranted];
      const withoutIndexOf = selection.indexOf("FALSE");
      if (withoutIndexOf > -1) {
        selection.splice(withoutIndexOf, 1);
      } else {
        selection.push("FALSE");
      }
      if (selection.length === 0) {
        return;
      }

      this.form.guaranted = selection;
    },
    toggleWithResult() {
      const selection = [...this.form.result];
      const withoutIndexOf = selection.indexOf("TRUE");
      if (withoutIndexOf > -1) {
        selection.splice(withoutIndexOf, 1);
      } else {
        selection.push("TRUE");
      }
      if (selection.length === 0) {
        return;
      }

      this.form.result = selection;
    },
    toggleWithoutResult() {
      const selection = [...this.form.result];
      const withoutIndexOf = selection.indexOf("FALSE");
      if (withoutIndexOf > -1) {
        selection.splice(withoutIndexOf, 1);
      } else {
        selection.push("FALSE");
      }
      if (selection.length === 0) {
        return;
      }

      this.form.result = selection;
    },
    toggleAssociatedNo() {
      this.form.onlyAssociated = false;
    },
    toggleAssociatedYes() {
      this.form.onlyAssociated = true;
    },
    async downloadCSV() {
      try {
        const payload = this.search();
        this.isCsvDownloadDisabled = true;
        const response = await this.$store.dispatch(
          "Stock/ITEM_HISTORY_DOWNLOAD_CSV",
          payload
        );
        const newBlob = new Blob([response], { type: "text/csv" });

        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = "ANALISE-DE-ITENS.csv";
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
        this.$toasted.success("Arquivo gerado com sucesso");
      } catch (error) {
        this.$toasted.error("Não conseguimos gerar seu arquivo");
      } finally {
        this.isCsvDownloadDisabled = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-analysis/components/event-filter/EventFilter.vue